import React, { useState, useEffect } from "react";
import SocketIOContext from "./SocketProvider/SocketIOContext";
import { Dlog } from "../../utils/Dlog";

import { getCheckedAuthToken } from "./../../utils/api";
//import { get, post, simpleget, simplepost } from "./utils/api";
import {
  addThemeTranslation,
  syncInitializeTranslations
} from "./../../utils/translations";
import { setLocale } from "react-i18nify";

import { io } from "socket.io-client";

let env = require("../../env");
let moment = require("moment-timezone");

const APP_URL = env.REACT_SCOCKETIO_URL;

const socket = io(APP_URL + "/kiosk", {
  autoConnect: true
});

// const tryGetCheckedAuthToken = async () => {
//   try {
//     return await getCheckedAuthToken();
//   } catch (err) {
//     console.log("tryGetCheckedAuthToken", err);
//     return null;
//   }
// };

// const socket = io(APP_URL + "/kiosk", {
//   autoConnect: true,
//   auth: { token: await tryGetCheckedAuthToken() }
// });

// In-Progress
// const adminsocket = io(APP_URL + "/admin", {
//   autoConnect: true
// });

//Used since, pulling from kioskconfiguration doesn't seem to work from within SocketIOProvider
let kioskconfigurationvalue = null;

export const SocketIOProvider = props => {
  const [isConnected, setIsConnected] = useState(false);
  const [socketEvents, setSocketEvents] = useState(null);
  const [socketEventsCounter, setSocketEventsCounter] = useState(0);

  const [configuration, setConfiguration] = useState(null);
  const [kioskconfiguration, setKioskConfiguration] = useState(null);
  const [kioskTheme, setKioskTheme] = useState({});

  const [qrCode, setQrCode] = useState("");
  const [qrCodeExpireTime, setQrCodeExpireTime] = useState("");

  const [syncTimeOffset, setSyncTimeOffset] = useState(null);

  const connect = () => {
    console.log("[SocketIOProvider] Attempting connect");
    if (!socket.connected) {
      console.log("[SocketIOProvider] Not connected, so do connection!");
      socket.connect();
    }
  };

  const disconnect = () => {
    console.log("[SocketIOProvider] Attempting disconnect");
    if (socket.connected) {
      console.log("[SocketIOProvider] Connected, so do disconnection!");
      socket.disconnect();
    }
  };

  const getSocket = () => {
    return socket;
  };

  const adminconnect = () => {
    //adminsocket.connect();
  };

  const admindisconnect = () => {
    //adminsocket.disconnect();
  };

  const getAdminSocket = () => {
    //return adminsocket;
    throw "Not Implimented";
  };

  const sendEvent = (payload, receiveEventCallback) => {
    socket.emit("event", payload);
  };

  const sendQRCodeCheck = kioskID => {
    socket.emit("qrcodecheck", { kioskId: kioskID });
  };

  const clearSocketEvents = () => {
    setSocketEvents(null);
  };

  const getConfiguration = () => {
    return configuration;
  };

  const getKioskConfiguration = () => {
    return kioskconfiguration;
  };

  const getKioskTheme = () => {
    return kioskTheme;
  };

  const updateTranslations = translations => {
    for (const [key, value] of Object.entries(translations)) {
      console.log("[updateTranslations]", key, value);
      addThemeTranslation(key, value.Fr, value.En);
    }
    syncInitializeTranslations();
  };

  useEffect(() => {
    console.log("SOCKET.io INITIALIZATION");

    function onConnect() {
      setIsConnected("true");
    }

    function onDisconnect() {
      setIsConnected("false");
    }

    async function onEvent(value) {
      let counter = socketEventsCounter + 1; //Used to just trigger an event, even if the value is the same as previous
      let socketvalue = { data: value, counter: counter };

      //If the event is a ADVANCE action, there should be a qrcode
      //console.log("onEvent value:", value);
      if (value.action == "ADVANCE") {
        // console.log(
        //   "[onEvent] Initializing Code and Expire Time:",
        //   value.newqrcode.key,
        //   value.newqrcode.expire
        // );

        if (value.configuration !== undefined && value.configuration !== null) {
          await setConfiguration(value.configuration);
        } else {
          console.log("configuration not found in ADVANCE event");
        }

        //No Kiosk settings????
        if (value.theme !== undefined && value.theme !== null) {
          const newKioskTheme = {
            ...kioskTheme,
            ...value.theme
          };
          console.log("SocketIOProvider newKioskTheme", newKioskTheme);
          await setKioskTheme(newKioskTheme);

          //Set default language as ENLGISH
          if (newKioskTheme.bilingual == false) {
            setLocale("en");
          }

          if (newKioskTheme.translations) {
            updateTranslations(newKioskTheme.translations);
          } else {
            console.error("No translations provided");
          }
        } else {
          console.log("kioskTheme not found in ADVANCE event");
        }

        if (value.kioskSettings !== undefined && value.kioskSettings !== null) {
          const newKioskSettings = {
            ...kioskconfiguration,
            ...value.kioskSettings
          };
          console.log("SocketIOProvider newKioskSettings", newKioskSettings);
          await setKioskConfiguration(newKioskSettings);
          kioskconfigurationvalue = newKioskSettings;
        } else {
          console.log("kioskSettings not found in ADVANCE event");
        }

        await setQrCode(value.newqrcode.key);
        await setQrCodeExpireTime(value.newqrcode.expire);
      }

      if (value.action == "UPDATE_INFO") {
        console.log("socket UPDATE_INFO", value);
      }

      // setSocketEvents(null);

      //let socketvalue = { data: value, counter: Date.now };

      //If Event is QR CODE Update, save to context
      await setSocketEvents(socketvalue);
      //console.log("SocketIOProvider onEvent socketvalue", socketvalue);

      //console.log("onEvent receiveEventFunc", receiveEventFunc);
      //if (receiveEventFunc) {
      //console.log("onEvent emit to receiveEventFunc");
      //receiveEventFunc("GOT AN EVENT");
      //}

      await setSocketEventsCounter(counter);
    }

    function onUpdateQRCode(value) {
      console.log(
        "[onUpdateQRCode] Updating Code and Expire Time:",
        value.key,
        value.expire
      );
      setQrCode(value.key);
      setQrCodeExpireTime(value.expire);
    }

    function onUpdateKioskSettings(value) {
      //using kioskconfigurationvalue since kioskconfiguration isn't updated from setKioskConfiguration
      if (kioskconfigurationvalue == null) {
        console.log("onUpdateKioskSettings kioskconfiguration from null");
        setKioskConfiguration(value);
        kioskconfigurationvalue = value;
      } else {
        const newvalue = { ...kioskconfigurationvalue, ...value };
        //console.log("newvalue", newvalue);
        setKioskConfiguration(newvalue);
        kioskconfigurationvalue = newvalue;
      }
    }

    function onUpdateKioskTheme(value) {
      //using kioskconfigurationvalue since kioskconfiguration isn't updated from setKioskConfiguration
      // if (kioskconfigurationvalue == null) {
      //   console.log("onUpdateKioskSettings kioskconfiguration from null");
      //   setKioskConfiguration(value);
      //   kioskconfigurationvalue = value;
      // } else {
      //   const newvalue = { ...kioskconfigurationvalue, ...value };
      //   //console.log("newvalue", newvalue);
      //   setKioskConfiguration(newvalue);
      //   kioskconfigurationvalue = newvalue;
      // }
      console.log("SocketIOProvider value", value);

      //No Kiosk settings????
      if (value.theme !== undefined && value.theme !== null) {
        const newKioskTheme = {
          ...kioskTheme,
          ...value.theme
        };
        console.log("SocketIOProvider newKioskTheme", newKioskTheme);
        setKioskTheme(newKioskTheme);

        if (newKioskTheme.translations) {
          updateTranslations(newKioskTheme.translations);
        } else {
          console.error("No translations provided");
        }
      }
    }

    function onConnectError(err) {
      console.log("[onConnectError] ", err);

      if (err.message === "Token expired") {
        console.log("[onConnectError] Token expired!");
        // // Request a new token from your auth endpoint
        //const newToken = await getCheckedAuthToken();
        getCheckedAuthToken().then(newToken => {
          console.log(
            "[onConnectError] Using updated token to reconnect socket"
          );
          socket.auth = { token: newToken };
          socket.connect(); // Reconnect with new token
        });
      }
    }

    //const interval = setInterval(() => onTick(), 1000);

    socket.on("connect", onConnect);
    socket.on("disconnect", onDisconnect);
    socket.on("event", onEvent);
    socket.on("updateqrcode", onUpdateQRCode);
    socket.on("updatekiosksettings", onUpdateKioskSettings);
    socket.on("updatekiosktheme", onUpdateKioskTheme);
    socket.on("connect_error", onConnectError);

    return () => {
      socket.off("connect", onConnect);
      socket.off("disconnect", onDisconnect);
      socket.off("event", onEvent);
      socket.off("updateqrcode", onUpdateQRCode);
      socket.off("updatekiosksettings", onUpdateKioskSettings);
      socket.off("updatekiosktheme", onUpdateKioskTheme);
      socket.off("connect_error", onConnectError);
      //return () => clearInterval(interval);
    };
  }, []);

  //const [state, setState] = useState(initState);

  return (
    <SocketIOContext.Provider
      value={{
        isConnected,
        socketEvents,
        qrCode,
        qrCodeExpireTime,
        syncTimeOffset,
        connect,
        disconnect,
        getSocket,
        sendEvent,
        sendQRCodeCheck,
        clearSocketEvents,
        setQrCode,
        setQrCodeExpireTime,
        setSyncTimeOffset,
        adminconnect,
        admindisconnect,
        getAdminSocket,
        getConfiguration, //Maybe ads????
        getKioskConfiguration, //This has the workflow setting
        getKioskTheme
      }}
    >
      {props.children}
    </SocketIOContext.Provider>
  );
};
export const SocketIOConsumer = SocketIOContext.Consumer;
export default SocketIOContext;
